/* eslint-disable @typescript-eslint/no-unused-vars */
/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import { IRootState } from 'src/redux/interface';
import {
    apiGetProfileInfo,
    getILABalance,
    apiUpdateAccount,
    apiGetStatusKYCFromBlockPass,
    apiUpdateOtherWallet,
    apiGetAccountLockTierInfo,
} from 'src/modules/Accounts/redux/Account.service';
import { apiLeaderBoard } from 'src/modules/Collections/redux/Collections.service';
import BigNumber from 'bignumber.js';
import { actionLogout as logOutAuth } from 'src/modules/Auth/Auth.actions';
import { actionLogout as logOutWhiteList } from 'src/modules/WhiteList/redux/WhiteList.action';
import { actionLogout as logOutAccount } from 'src/modules/Accounts/redux/Account.action';
import { ENVS } from '../../../configs/Configs.env';

export const ACTION_TYPES = {
    GET_ILA_BALANCE: 'GET_ILA_BALANCE',
    CLEAR_ILA_BALANCE: 'CLEAR_ILA_BALANCE',
    GET_ILA_LOCK_TIER: 'GET_ILA_LOCK_TIER',
    CLEAR_ILA_LOCK_TIER: 'CLEAR_ILA_LOCK_TIER',
    UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
    LOGOUT: 'LOGOUT',
    GET_TRADING_VOLUME: 'GET_TRADING_VOLUME',
    CLEAR_TRADING_VOLUME: 'CLEAR_TRADING_VOLUME',
    UPDATE_WALLETS: 'UPDATE_WALLETS',
};

export interface IAccountState {
    IsVerifiedEmail?: boolean;
    Address?: string;
    KYCStatus?: boolean;
    KYCRefId?: string;
    KYCRecordId?: string;
}

export const actionUpdateAccount = (payload: IAccountState) => ({
    type: ACTION_TYPES.UPDATE_ACCOUNT,
    payload,
});

export const actionLogout = () => ({
    type: ACTION_TYPES.LOGOUT,
});

export const actionGetProfileInfo =
    (checkKYC: number, token: string) => async (dispatch: any, getState: () => IRootState) => {
        try {
            let dataGetProfile = await apiGetProfileInfo(checkKYC, token);
            if (dataGetProfile?.result) {
                dispatch({ type: ACTION_TYPES.UPDATE_ACCOUNT, payload: dataGetProfile.result });
                if (checkKYC && dataGetProfile?.result?.KYCStatus === 0 && dataGetProfile?.result?.KYCRefId === '') {
                    const KYCRefId = `${ENVS.REACT_APP_BLOCK_PASS_CLIENT_ID}_${dataGetProfile?.result?.ID}`;
                    let dataKyc = await apiGetStatusKYCFromBlockPass(KYCRefId);
                    if (dataKyc?.status === 'success') {
                        let dataUpdate = await apiUpdateAccount({ KYCRefId }, token);
                        if (dataUpdate?.error == null) {
                            let data = await apiGetProfileInfo(checkKYC, token);
                            if (data?.result) {
                                dispatch({ type: ACTION_TYPES.UPDATE_ACCOUNT, payload: data.result });
                            }
                        }
                    }
                }
            } else {
                dispatch(logOutAuth());
                dispatch(logOutWhiteList());
                dispatch(logOutAccount());
            }
        } catch (e) {
            console.log('actionGetProfileInfo error: ', e);
            dispatch(logOutAuth());
            dispatch(logOutWhiteList());
            dispatch(logOutAccount());
        }
    };

export const getILABalanceAction = (walletAddress: any) => async (dispatch: any) => {
    try {
        const { ilaInWallet, lockInfo }: any = await getILABalance(walletAddress);
        dispatch({
            type: ACTION_TYPES.GET_ILA_BALANCE,
            payload: {
                ilaBalance: ilaInWallet / 10 ** 18,
                lockedIn: Number(lockInfo[0]) / 10 ** 18,
                lastDeposit:
                    Number(lockInfo[1]) === 0
                        ? Number(lockInfo[1])
                        : Math.ceil(
                              (new Date().getTime() - new Date(Number(lockInfo[1]) * 1000).getTime()) /
                                  (1000 * 3600 * 24),
                          ) - 1,
                currentPenalty: Number(lockInfo[2]),
            },
        });
    } catch (error) {
        dispatch({
            type: ACTION_TYPES.GET_ILA_BALANCE,
            payload: {
                ilaBalance: 0,
                lockedIn: 0,
                lastDeposit: 0,
                currentPenalty: 0,
            },
        });
    }
};

export const getAccountLockTierInfo = (walletAddress: any, contractAddr: any) => async (dispatch: any) => {
    try {
        const { accountInfo }: any = await apiGetAccountLockTierInfo(walletAddress, contractAddr);
        const apr = new BigNumber(accountInfo[0]).div(10 ** 18).toNumber();
        const tierAPR = accountInfo[1] / 100;
        const amount = new BigNumber(accountInfo[2]).div(10 ** 18).toNumber();
        const reward = new BigNumber(accountInfo[3]).div(10 ** 18).toNumber();
        const lastStakeTime = Number(accountInfo[4]);
        const lastUpdate = Number(accountInfo[5]);
        dispatch({
            type: ACTION_TYPES.GET_ILA_BALANCE,
            payload: {
                apr,
                tierAPR,
                amount,
                reward,
                lastStakeTime,
                lastUpdate,
            },
        });
    } catch (error) {
        dispatch({
            type: ACTION_TYPES.CLEAR_ILA_LOCK_TIER,
            payload: {
                apr: 0,
                tierAPR: 0,
                amount: 0,
                reward: 0,
                lastStakeTime: 0,
                lastUpdate: 0,
            },
        });
    }
};

export const actionGetNFTLog = (walletAddress: any) => async (dispatch: any) => {
    try {
        const dataGetNFT: any = await apiLeaderBoard(walletAddress, 'bony-bastards');
        dispatch({
            type: ACTION_TYPES.GET_TRADING_VOLUME,
            payload: {
                tradingVolume: new BigNumber(dataGetNFT?.TotalVolume.toString()).div(10 ** 18).toString(),
                rank: dataGetNFT?.Rank,
            },
        });
    } catch (error) {
        dispatch({
            type: ACTION_TYPES.GET_TRADING_VOLUME,
            payload: {
                tradingVolume: 0,
                rank: 0,
            },
        });
    }
};

export const actionUpdateKycRefIdToProfile = (kycRefId: string, token: string) => async (dispatch: any) => {
    try {
        const data = await apiUpdateAccount({ KYCRefId: kycRefId }, token);
    } catch (e) {
        console.log('actionUpdateKycRefIdToProfile error: ', e);
    }
};

export const actionUpdateOtherWallet = (data: any, token: string) => async (dispatch: any) => {
    try {
        await apiUpdateOtherWallet({ Wallets: JSON.stringify(data.Wallets) }, token);
        dispatch({
            type: ACTION_TYPES.UPDATE_WALLETS,
            payload: data.Wallets,
        });
    } catch (e) {
        console.log('actionUpdateKycRefIdToProfile error: ', e);
    }
};
